










import { mixins } from 'vue-class-component';
import { Component, Prop, Watch } from 'vue-property-decorator';
import Chart from 'chart.js';
import _ from 'lodash';
import { utilService } from '../util-service';
import chartUtil from './util.service';
import SwChartChartJsMixin from './sw-chart-chart-js.mixin.vue';
import { ChartOptions, AnnotationConfig, StaticLabelOptions } from './types';

@Component
export default class SwChartCompareBar extends mixins(SwChartChartJsMixin) {
  @Prop({ type: Array, default () { return []; }, required: true })
  chartData: Chart.ChartDataSets[];

  @Prop(Array)
  labels: string[];

  @Prop({ type: Boolean, default: true })
  xLabelsDisplay: boolean;

  @Prop({ type: Boolean, default: true })
  yLabelsDisplay: boolean;

  @Prop({ type: Array })
  colorPalette: string[];

  @Prop({ type: Object, default() { return {}; } })
  axisOpts: Chart.ChartScales;

  @Prop(Object)
  annotationConfig: AnnotationConfig;

  @Prop({ type: Object, default() { return { enable: false }; } })
  staticLabelOpts: StaticLabelOptions;

  @Prop({ type: Boolean, default: false })
  horizontal: boolean;

  get chartOptions(): ChartOptions & { cornerRadius: number } {
    const options: ChartOptions & { cornerRadius: number } = {
      cornerRadius: 10,
      scales: _.merge(
        {
          xAxes: [{
            categoryPercentage: 0.7,
            maxBarThickness: 8,
            gridLines: {
              color: chartUtil.chartGridColor(this.theme),
            },
            ticks: {
              fontColor: chartUtil.chartTextColor(this.theme),
              display: this.xLabelsDisplay ? true : false,
            },
          }],
          yAxes: [{
            categoryPercentage: 0.7,
            maxBarThickness: 8,
            gridLines: {
              color: chartUtil.chartGridColor(this.theme),
            },
            ticks: {
              fontColor: chartUtil.chartTextColor(this.theme),
              display: this.yLabelsDisplay ? true : false,
              min: 0,
            },
          }],
        },
        this.axisOpts,
      ),
      legend: {
        display: false,
      },
      layout: {
        padding: {
          top: this.staticLabelOpts.enable ? 15 : 0,
        },
      },
      annotation: this.annotationConfig,
      tooltips: {
        enabled: !this.staticLabelOpts.enable,
      },
      plugins: {
        staticlabel: this.staticLabelOpts,
      },
    };
    return _.merge(options, this.options);
  }

  get normalizedDatasets(): Chart.ChartDataSets[] {
    const providedPalette = this.colorPalette || utilService.colorConst.chartPrimaryPalette;
    const candLength = providedPalette.length;

    return this.chartData.map<Chart.ChartDataSets>((ds: any, index: number) => {
      return {
        data: ds.data,
        label: ds.label,
        backgroundColor: providedPalette[index % candLength],
        borderWidth: 0,
      };
    });
  }

  @Watch('labels')
  @Watch('normalizedDatasets')
  @Watch('chartOptions')
  private onConfigChanged() {
    if (this.chartInstance) {
      this.updateData();
      (this.chartInstance as any).options = this.chartOptions;
      this.chartInstance.update();
    }
  }

  private updateData() {
    if (this.chartInstance) {
      chartUtil.updateChartRegularData(this.chartInstance, this.labels, this.normalizedDatasets);
    }
  }

  created() {
    this.myCssPrefix = 'sw-chart-bar';
  }

  mounted() {
    this.initChart({
      type: this.horizontal ? 'horizontalRoundedBar' : 'roundedBar',
      data: {
        labels: this.labels,
        datasets: this.normalizedDatasets,
      },
      options: this.chartOptions,
    });
  }
}
